import * as React from "react";
import * as ReactDOM from "react-dom";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Cancel } from "../../../assets/logos/icons";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import "./modal-buy-credits.css"

const ModalBuyCredits = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = React.useState(true);
    const history = useHistory();
    
    const toggleDialog = () => {
      setVisible(!visible);
    };
    return (
      <div>
        {visible && (
          <Dialog title={t("modalBuyCredits.title")} onClose={toggleDialog}>
          <p style={{ textAlign: "center", marginTop: "20px" }}>
            <img alt="modalBuyCredits-img-cancel" src={Cancel} />
          </p>
            <p className="modalBuyCredits-p-text">
              {t("modalBuyCredits.text")}
            </p>
            <DialogActionsBar>
              <div className="modalBuyCredits-container-buttons">
                <button
                  onClick={() => history.goBack()}
                  className="modalBuyCredits-button-cancel"
                >
                  {t("modalBuyCredits.button.cancel")}
                </button>
                <Link to="/new-plan-renovation">
                <button
                  className="modalBuyCredits-button-buy"
                >
                  {t("modalBuyCredits.button.buy.credits")}
                </button>
                </Link>
              </div>
            </DialogActionsBar>
          </Dialog>
        )}
      </div>
    );
  };
  

export { ModalBuyCredits as default };
